import {createReducer} from '@reduxjs/toolkit';

import * as searchActions from '../actions/search.js';

const resetState = {
  dailyEmailEnabled: false,
  geometry: null,
  geometryId: null,
  geometryTooLarge: true,
  geometryZoomTo: true,
  id: null,
  isGeometryTooComplex: false,
  name: '',
  noEndDate: false,
  page: 0,
  singleItemSearchId: null,
};

export const initialState = {
  dateRanges: [],
  maxVertexCount: 500,
  ...resetState,
};

const search = createReducer(initialState, builder => {
  builder.addCase(searchActions.saveGeometry, (state, {payload}) => {
    const {
      geometry,
      geometryTooLarge,
      geometryZoomTo,
      isGeometryTooComplex,
      name,
    } = payload;

    state.geometry = geometry;
    (state.geometryId = state.geometryId === null ? 1 : state.geometryId + 1),
      (state.geometryTooLarge = geometryTooLarge);
    state.geometryZoomTo = geometryZoomTo;
    state.id = initialState.id;
    state.isGeometryTooComplex = isGeometryTooComplex;
    state.name = name;
    state.singleItemSearchId = initialState.singleItemSearchId;
  });

  builder.addCase(searchActions.clearSearch, state => {
    return {
      ...state,
      ...resetState,
    };
  });
});

export default search;
